import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import ResumiPraTiApp from './ResumiPraTiApp';
import './styles/global.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ResumiPraTiApp />
    </HelmetProvider>
  </React.StrictMode>
);